import * as TYPES from '../types';
import { REDUX_CONSTANT } from '../../constants';

const initialState = {
    isLoading: false,
    licenseeMarkPdfData: null,
    licenseeMarkZipData: null
};

export default function resourcesReducer(state = initialState, action) {
    switch (action.type) {
        case REDUX_CONSTANT.CLEAR_LICENSEE_MARK_DATA:
            return {
                ...state,
                licenseeMarkPdfData: null,
                licenseeMarkZipData: null,
                isLoading: false
            };
        case REDUX_CONSTANT.LICENSEE_MARK_PDF_DATA:
            return {
                ...state,
                isLoading: false,
                licenseeMarkPdfData: action.payload
            };
        case REDUX_CONSTANT.LICENSEE_MARK_ZIP_DATA:
            return {
                ...state,
                isLoading: false,
                licenseeMarkZipData: action.payload
            };
        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading:
                    action.payload.title ===
                        REDUX_CONSTANT.LICENSEE_MARK_PDF_DATA ||
                    action.payload.title ===
                        REDUX_CONSTANT.LICENSEE_MARK_ZIP_DATA
                        ? true
                        : state.isLoading
            };

        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                licenseeMarkPdfData:
                    action.payload.title ===
                    REDUX_CONSTANT.LICENSEE_MARK_PDF_DATA
                        ? action.payload.msg
                        : state.licenseeMarkPdfData,
                licenseeMarkZipData:
                    action.payload.title ===
                    REDUX_CONSTANT.LICENSEE_MARK_ZIP_DATA
                        ? action.payload.msg
                        : state.licenseeMarkZipData
            };
        default:
            return state;
    }
}
